import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {RoomPlannerProductWithTemplate} from 'components/customer/RoomPlanner/types';
import {
    isBaseCornerCabinet,
    isCornerPantryCabinet,
} from 'components/customer/Preview3D/types';

/**
 * L-shape input parameters for cabinet normalization
 */
export interface LShapeInputs {
    cabinetLeftDepth: number;
    cabinetRightDepth: number;
    cabinetLeftWidth: number;
    cabinetRightWidth: number;
    cabinetHeight: number;
    doorGap: number;
    doorTop: number;
    doorBottom: number;
    doorLeft: number;
    doorRight: number;
    doorThickness: number;
    carc: number;
    isBaseCorner: boolean;
    isCornerPantry: boolean;
}

/**
 * Builds L-shape input parameters for cabinet normalization and door margin corrections
 * @param {RoomPlannerProductWithTemplate} values - Product values
 * @param {TemplateVariable} variables - Template variables
 * @param {number} carcThickness - Carcase thickness
 * @return {LShapeInputs} L-shape input parameters
 */
export const buildLShapeInputs = (
    values: RoomPlannerProductWithTemplate,
    variables: TemplateVariable,
    carcThickness: number
): LShapeInputs => {
    return {
        cabinetLeftDepth: Number(values.cabinet_left_depth),
        cabinetRightDepth: Number(values.cabinet_right_depth),
        cabinetLeftWidth: Number(values.cabinet_left_width),
        cabinetRightWidth: Number(values.cabinet_right_width),
        cabinetHeight: Number(values.cabinet_height),
        doorGap: Number(values.cabinet_door_gap) || 0,
        doorTop: Number(values.cabinet_door_top) || 0,
        doorBottom: Number(values.cabinet_door_bottom) || 0,
        doorLeft: Number(values.cabinet_door_left) || 0,
        doorRight: Number(values.cabinet_door_right) || 0,
        doorThickness: Number(values.cabinet_ext_thickness),
        carc: Number(carcThickness),
        isBaseCorner: isBaseCornerCabinet(variables, values),
        isCornerPantry: isCornerPantryCabinet(variables, values),
    };
};
